document.addEventListener('DOMContentLoaded', function () {
  var slideshows = document.querySelectorAll('[data-ck-slideshow]');

  slideshows.forEach(function (show) {
    var wrapper = show.closest('.ck_ls_service-block-media');
    if (!wrapper) return;

    var slides = show.querySelectorAll('.ck_ls_slide');
    var controls = wrapper.querySelector('.ck_ls_slideshow-controls');
    if (!controls || slides.length < 2) return;

    var dots = controls.querySelectorAll('.ck_ls_slide-dot');
    var prevBtn = controls.querySelector('[data-ck-slide-prev]');
    var nextBtn = controls.querySelector('[data-ck-slide-next]');
    var current = 0;

    function goTo(index) {
      var count = slides.length;
      current = (index + count) % count;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
      });
    }
  });
});
